import React from 'react';

import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

export default class ApplyCancelInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialValue: this.props.value,
            newValue: this.props.value,
            error: false,
            validationError: this.props.validate ? !this.props.validate(this.props.value) : false
        };

        this.onChange = this.onChange.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.initialValue) {
            this.setState({ 
                initialValue: nextProps.value, 
                newValue: nextProps.value,
                validationError: this.props.validate ? !this.props.validate(nextProps.value) : false
            });
        }
    }


    onChange(e) {
        const newValue = e.target.value;
        this.setState({ newValue }, () => {
            this.validate(newValue);
        });
    }

    hasValue(value) {
        return value && value.trim() !== '';
    }

    validate(value) {
        let requiredError = this.props.required && !this.hasValue(value);
        let validationError = this.props.validate ? !this.props.validate(value) : false;
        this.setState({ requiredError, validationError });
    }

    async apply() {
        this.setState({ error: false });
        await this.props.update(this.state.newValue);
        if (!this.props.success) {
            this.setState({ error: true });
        }
    }

    cancel() {
        this.setState({ initialValue: this.props.value, newValue: this.props.value, error: false,   validationError: this.props.validate ? !this.props.validate(this.state.initialValue) : false });
    }

    render() {
        const { initialValue, newValue, validationError } = this.state;
        const valuesUnequal = (newValue ? newValue.toString() : '') !== (initialValue ? initialValue.toString() : '');
        const isInvalid = validationError;

        const input = React.cloneElement(this.props.input, {
            name: 'newValue',
            value: newValue || '',
            className: `${this.props.input.props.className || ""} ${(validationError) ? " error-input" : ""}`,
            onKeyDown: (e) => {if(e.key === 'Enter' && valuesUnequal && !isInvalid) this.apply()},
            onChange: this.onChange,
            onBlur: (e) => this.validate(e.target.value)

        });

        return (
            <div>
                <label className="input-label">{this.props.title}</label>
                {input}
                <FadeOutErrorMessage show={validationError} message={this.props.errorMessage || "Invalid entry"} />
                <div className="settings-btns">
                    {valuesUnequal && <div>
                        {this.props.loading ?
                            <LoadingSpinner height={20} loading={this.props.loading} /> :
                            <div>
                                <button className="btn btn-small btn-primary icon-left" disabled={isInvalid ||!newValue} onClick={this.apply.bind(this)}>Apply</button>
                                <button className="btn btn-small btn-accent" onClick={this.cancel.bind(this)}>Cancel</button>
                            </div>}
                    </div>}
                </div>
            </div>
        );
    }

}

//value, update, title, success, loading


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/ApplyCancelInput.jsx